@if(purchasesResponse; as data)
{

@for(purchase of data.purchases; track purchase.purchaseId)
{
<div class="w-full bg-white rounded-lg overflow-hidden border-b border-gray-300 py-4 px-4
         grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-0  items-stretch">

    <!-- col1 -->
    <div class=" order-1 md:order-1  flex flex-col  items-start ">
        <div>
            <p class="text-lg font-noto-serif text-[var(--fs-black)] cursor-pointer hover:underline "
                [routerLink]="['/auction', purchase.auctionId]">
                {{ purchase.organizationName }}
            </p>
            <p class="hidden md:block  font-dm-sans text-lg text-[var(--dark-blue)]">
                Quantity: {{ purchase.lineItemsCount }}
            </p>
        </div>


    </div>

    <!-- col2 -->
    <div class="order-3 md:order-2 flex flex-col w-full items-start md:items-center -mt-[10px] md:mt-0">
        <p class="font-dm-sans text-[var(--charcoal)] text-lg m-0">
            {{purchase.cardType !== null ? purchase.cardType + ' - ' + purchase.cardEndDigits :
            capitalize(purchase.paymentType) }}
        </p>

        @if( purchase.processingPhase !== 'SUCCEEDED' && purchase.cardType)
        {
        <p class="font-dm-sans text-xs text-[var(--dark-blue)] font-bold mt-1 md:mt-5 m-0 cursor-pointer"
            (click)="onOpenPopover($event, popover)">
            Change Card
        </p>
        }

        <p-popover #popover styleClass="!p-0 shadow-md rounded-lg border border-gray-200 mx-4 md:mx-0">
            <div class="flex items-center gap-2 p-2 md:p-0">
                <p-select [options]="cardOptions().slice(0, 4)" optionLabel="label" optionValue="value" top="4"
                    [(ngModel)]="selectedCard" placeholder="Select new card" class="w-full text-sm"></p-select>

                <p-button label="Change" size="small" (click)="patchCreditCard(purchase.purchaseId); popover.hide()" />
            </div>
        </p-popover>
    </div>

    <!-- col3 -->
    <div class="order-4 md:order-3 flex flex-col items-end md:items-center">
        <div class="flex flex-col md:items-center items-end md:justify-center [&>p]:m-0">
            <div class="flex items-center gap-1 lg:mb-5">

                <p class=" text-sm md:text-lg font-dm-sans font-semibold text-[var(--fs-black)] m-0">
                    ${{ purchase.total.toFixed(2) }} {{purchase.currency}}
                </p>
                <p class="font-dm-sans text-xs text-[var(--dark-blue)] font-bold m-0">Total</p>
            </div>
            <p class="font-dm-sans text-xs text-[var(--dark-blue)] font-bold m-0 cursor-pointer"
                (click)="onOpenModal(purchase)">See details</p>
        </div>

    </div>

    <!-- col4 -->
    <div class="order-2 md:order-4 flex flex-col items-end md:mt-6 md:items-start md:items-center ">

        <p [ngClass]="{
      'bg-[#07A279] text-white': purchase.processingPhase === 'SUCCEEDED',
      'bg-[#FFDE5F] text-black': purchase.processingPhase === 'UNPROCESSED',
      'bg-[#E85C5C] text-black': purchase.processingPhase === 'FAILED'
    }" class="status-pill">
            {{ capitalize(purchase.processingPhase) }}
        </p>


        <p class="block md:hidden  font-dm-sans text-lg text-[var(--dark-blue)] m-0 mt-1">
            Purchases: {{ purchase.lineItemsCount }}
        </p>
    </div>
</div>
}

}

<p-dialog [(visible)]=" displayModal" [modal]="true" [closable]="true" [style]="{ width: '98vw', maxWidth: '500px' }">

    <div style="max-height:75vh; overflow-y:auto; position:relative; padding:1rem;">

        @if(selectedPurchase){
        <p class="font-dm-sans text-[var(--dark-teal)] font-semibold text-xl">{{selectedPurchase.organizationName}}</p>

        <div class=" flex justify-between items-center">
            <p class="font-dm-sans text-[var(--charcoal)] text-sm flex items-center">Last modified:
                {{selectedPurchase.lastModifiedDate |
                date:'MMM d, y'}}
            </p>
            <p class="px-3 py-1 rounded-full text-xs font-semibold  text-center h-[25px] w-[100px]" [ngClass]="{
                    'bg-[#07A279] text-white': selectedPurchase.processingPhase === 'SUCCEEDED',
                    'bg-[#FFDE5F] text-black': selectedPurchase.processingPhase === 'UNPROCESSED',
                    'bg-[#E85C5C] text-black': selectedPurchase.processingPhase === 'FAILED'
                    }">
                {{capitalize(selectedPurchase.processingPhase)}}
            </p>
        </div>

        <div class="border rounded-lg border-custom-blue bg-cyan-50 py-4 px-4">
            <div class="flex justify-between">
                <p class="text-[var(--sky-blue)] text-sm font-semibold m-0">Purchases</p>
                <p class="font-dm-sans text-[var(--charcoal)] text-sm text-right m-0">
                    {{ selectedPurchase.lineItemsCount }}
                </p>
            </div>
            <div class="flex justify-between">
                <p class="text-[var(--sky-blue)] text-sm font-semibold m-0">Payment Method</p>
                <p class="font-dm-sans text-[var(--charcoal)] text-sm text-right m-0">
                    {{selectedPurchase.cardType !== null ? selectedPurchase.cardType + ' - ' +
                    selectedPurchase.cardEndDigits :
                    capitalize(selectedPurchase.paymentType) }}
                </p>
            </div>
            <div class="flex justify-between">
                <p class="text-[var(--sky-blue)] text-sm font-semibold m-0">Date</p>
                <p class="font-dm-sans text-[var(--charcoal)] text-sm text-right m-0">
                    {{ selectedPurchase.lastModifiedDate |
                    date:'MMM d, y' }}
                </p>
            </div>
            <div class="flex justify-between">
                <p class="text-[var(--sky-blue)] text-sm font-semibold m-0">Fees Covered</p>
                <p class="font-dm-sans text-[var(--charcoal)] text-sm text-right m-0">
                    ${{ selectedPurchase.feeTotal.toFixed(2) }} {{selectedPurchase.currency}}
                </p>
            </div>
            <div class="flex justify-between">
                <p class="text-[var(--sky-blue)] text-sm font-semibold m-0">Total Amount</p>
                <p class="font-dm-sans text-[var(--charcoal)] text-sm text-right m-0">
                    ${{ selectedPurchase.total.toFixed(2) }} {{selectedPurchase.currency}}
                </p>
            </div>
        </div>


        @if(selectedPurchase.lineItems)
        {
        <p class="font-bold font-dm-sans text-[var(--dark-teal)] text-lg  mt-6">PURCHASED DETAILS</p>
        @for(item of selectedPurchase.lineItems; track $index)
        {

        <div class="border-b">
            <p class="text-lg font-bold font-dm-sans text-[var(--dark-teal)] m-0 mt-2 ">{{
                labelPurchaseType(item.type)}}</p>

            <p class="text-sm font-bold font-dm-sans text-[var(--dark-teal)] m-0 mt-2 ">{{item.name}}</p>
            <div class="flex justify-between">
                <p class="m-0 text-xs font-dm-sans text-[var(--charcoal)] ">{{item.lot}}</p>
                <p class="m-0  text-xs font-dm-sans text-[var(--charcoal)] font-semibold"> Tax:
                    <span class="font-normal">${{item.tax }} {{selectedPurchase.currency}}</span>
                </p>
            </div>
            <div class="flex justify-between lg:mt-2">
                <p class="m-0  text-xs font-dm-sans text-[var(--charcoal)] font-semibold"> Quantity:
                    <span class="font-normal">{{item.quantity}}</span>
                </p>
                <p class="m-0  text-xs font-dm-sans text-[var(--charcoal)] font-semibold"> Fee:
                    <span class="font-normal">${{item.fee}} {{selectedPurchase.currency}}</span>
                </p>
            </div>
            <div class="flex justify-between m-0">
                <p class="m-0  text-xs font-dm-sans text-[var(--charcoal)] font-semibold"> Amount:
                    <span class="font-normal">${{item.amount }} {{selectedPurchase.currency}}</span>
                </p>
                <p class="m-0 mb-3  text-xs font-dm-sans text-[var(--charcoal)] text-[var(--dark-teal)]  font-bold">
                    TOTAL:
                    <span class="text-black text-xs">${{item.lineTotal.toFixed(2) }}
                        {{selectedPurchase.currency}}</span>
                </p>
            </div>
        </div>
        }
        }
        <!-- }
        } -->

        <div class="flex flex-col justify-end items-end border-b space-y-2 py-2">
            <p class="m-0  text-xs font-dm-sans text-[var(--charcoal)] font-semibold"> Purchases:
                <span class="font-normal">{{ selectedPurchase.lineItemsCount}}</span>
            </p>

            <p class="m-0  text-xs font-dm-sans text-[var(--charcoal)] font-semibold"> Subtotal:
                <span class="font-normal">${{ selectedPurchase.subTotal.toFixed(2)}}
                    {{selectedPurchase.currency}}</span>

            </p>

            <p class="m-0  text-xs font-dm-sans text-[var(--charcoal)] font-semibold"> Tax:
                <span class="font-normal"> ${{ selectedPurchase.taxTotal.toFixed(2)}}
                    {{selectedPurchase.currency}}</span>

            </p>

            <p class="m-0  text-xs font-dm-sans text-[var(--charcoal)] font-semibold"> Shipping: <span
                    class="font-normal">${{ selectedPurchase.shipping.toFixed(2)}} {{selectedPurchase.currency}}</span>

            </p>

            <p class="m-0  text-xs font-dm-sans text-[var(--charcoal)] font-semibold"> Fees:
                <span class="font-normal">${{ selectedPurchase.feeTotal.toFixed(2)}}
                    {{selectedPurchase.currency}}</span>

            </p>
        </div>
        <p
            class="m-0 mb-5  text-lg font-dm-sans text-[var(--charcoal)] text-[var(--dark-teal)]  font-bold text-right mt-4">
            TOTAL:
            <span class="text-black text-lg">${{selectedPurchase.total.toFixed(2)}} {{selectedPurchase.currency}}</span>
        </p>
        }

        <p-scrolltop target="parent" [threshold]="100" icon="pi pi-chevron-up" class="block md:hidden"
            [buttonProps]="{ severity: 'contrast', raised: true, rounded: true }">
        </p-scrolltop>

    </div>
</p-dialog>

<div *ngIf="isLoadingPatch()" class="fixed inset-0 flex items-center justify-center bg-black/20 z-50">
    <p-progress-spinner></p-progress-spinner>
</div>